import React, { useState } from 'react';
import { MessageSquare, X, Send, HelpCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function ChatBot() {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="fixed bottom-6 right-6 z-50" data-id="element-58">
      <AnimatePresence data-id="element-59">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} className="absolute bottom-16 right-0 w-80 md:w-96 bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden flex flex-col" style={{
        height: '450px'
      }} data-id="element-60">
            {/* Header */}
            <div className="bg-uganda-green text-white p-4 flex justify-between items-center" data-id="element-61">
              <div className="flex items-center space-x-2" data-id="element-62">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center" data-id="element-63">
                  <HelpCircle className="w-5 h-5" data-id="element-64" />
                </div>
                <div data-id="element-65">
                  <h3 className="font-bold text-sm" data-id="element-66">MAAIF Assistant</h3>
                  <p className="text-xs text-green-100" data-id="element-67">
                    Online | Ready to help
                  </p>
                </div>
              </div>
              <button onClick={() => setIsOpen(false)} className="text-green-100 hover:text-white transition-colors" data-id="element-68">
                <X className="w-5 h-5" data-id="element-69" />
              </button>
            </div>

            {/* Chat Area */}
            <div className="flex-grow bg-gray-50 p-4 overflow-y-auto flex flex-col space-y-4" data-id="element-70">
              <div className="bg-white border border-gray-100 p-3 rounded-2xl rounded-tl-sm text-sm text-gray-700 shadow-sm self-start max-w-[85%]" data-id="element-71">
                Hello! Welcome to the Ministry of Agriculture portal. How can I
                assist you today?
              </div>

              {/* Quick Options */}
              <div className="flex flex-col space-y-2 mt-2" data-id="element-72">
                <button className="bg-white border border-uganda-green text-uganda-green hover:bg-green-50 text-xs py-2 px-3 rounded-full text-left transition-colors self-start" data-id="element-73">
                  How do I get an import/export permit?
                </button>
                <button className="bg-white border border-uganda-green text-uganda-green hover:bg-green-50 text-xs py-2 px-3 rounded-full text-left transition-colors self-start" data-id="element-74">
                  Where can I find sector statistics?
                </button>
                <button className="bg-white border border-uganda-green text-uganda-green hover:bg-green-50 text-xs py-2 px-3 rounded-full text-left transition-colors self-start" data-id="element-75">
                  How do I contact the Directorate of Crop Resources?
                </button>
                <button className="bg-white border border-uganda-green text-uganda-green hover:bg-green-50 text-xs py-2 px-3 rounded-full text-left transition-colors self-start" data-id="element-76">
                  What weather advisories are current?
                </button>
              </div>
            </div>

            {/* Input Area */}
            <div className="p-3 bg-white border-t border-gray-100 flex items-center" data-id="element-77">
              <input type="text" placeholder="Type your question..." className="flex-grow bg-gray-100 border-none rounded-full px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-uganda-green/50" data-id="element-78" />
              <button className="ml-2 w-10 h-10 bg-uganda-green text-white rounded-full flex items-center justify-center hover:bg-green-700 transition-colors shrink-0" data-id="element-79">
                <Send className="w-4 h-4 ml-0.5" data-id="element-80" />
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Floating Button */}
      <button onClick={() => setIsOpen(!isOpen)} className="w-14 h-14 bg-uganda-green text-white rounded-full shadow-xl flex items-center justify-center hover:bg-green-700 transition-transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-green-300 relative" data-id="element-81">
        {isOpen ? <X className="w-6 h-6" data-id="element-82" /> : <MessageSquare className="w-6 h-6" data-id="element-83" />}

        {/* Pulse Effect when closed */}
        {!isOpen && <span className="absolute inset-0 rounded-full border-2 border-uganda-green animate-ping opacity-75" data-id="element-84"></span>}
      </button>
    </div>;
}